
import { Vue, Component, Watch } from 'vue-property-decorator'
import { getInfo, setInfo } from '@/api/admin'
import { stringArrayToString, stringToStringArray } from '@/filters'
import { Form as ElForm } from 'element-ui'
import { setAdminRules } from '@/utils/rules'
import { delObjEmptyKey } from '@/utils'
@Component({
  name: 'adminDetail',
  props: {
    id: {
      type: Number,
    },
  },
})
export default class extends Vue {
  private infoForm: any = {
    username: '',
    email: '',
    password: '',
    status: null,
    available_currency: [],
    ip_address: [],
    manager_type: '',
    description: '',
    google_code: '',
  }
  private rules = setAdminRules
  private password: string = ''
  private capsTooltip = false
  private status: any = ''
  private ip_address: string = ''
  private loading = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private changeInput(e: any) {
    e.target.value = e.target.value.replace(
      /[`~!@#$%^&*()_\-+=<>?"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,
      ''
    )
  }

  // 编辑IP地址相关操作
  private openIpEdit: boolean = false
  private editIpAddress() {
    this.openIpEdit = true
  }
  private onAdd() {
    this.infoForm.ip_address.push('')
  }
  private onDel(i) {
    this.infoForm.ip_address.splice(i, 1)
  }
  private editIp() {
    this.infoForm.ip_address = this.infoForm.ip_address.filter((item) => {
      return item !== ''
    })
    this.openIpEdit = false
  }
  @Watch('infoForm.ip_address')
  private watchIp(i) {
    this.ip_address = stringArrayToString(i)
  }

  mounted() {
    this.getInfo()
  }

  async getInfo() {
    try {
      this.loading = true
      await getInfo(this.$props.id).then((res: any) => {
        this.infoForm = Object.assign(this.infoForm, res)
        this.ip_address = stringArrayToString(this.infoForm.ip_address)
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private checkCapslock(e: KeyboardEvent) {
    const { key } = e
    this.capsTooltip =
      key !== undefined &&
      key !== null &&
      key.length === 1 &&
      key >= 'A' &&
      key <= 'Z'
  }

  private ipAddressChange(e: any) {
    this.infoForm.ip_address = stringToStringArray(e)
  }

  private passwordChange(e: any) {
    this.infoForm.password = e
  }

  private back() {
    this.$emit('close', false)
  }
  private async update() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data: any = {
            ...this.infoForm,
            status: this.status,
          }
          delObjEmptyKey(data)
          this.loading = true
          await setInfo(data).then(() => {
            this.$message({
              message: 'Edit success',
              type: 'success',
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.back()
        }
      } else {
        return false
      }
    })
  }
}
